import { render, staticRenderFns } from "./CtaSectionWithBackground.vue?vue&type=template&id=5bf9dd86&scoped=true"
import script from "./CtaSectionWithBackground.vue?vue&type=script&setup=true&lang=ts"
export * from "./CtaSectionWithBackground.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CtaSectionWithBackground.vue?vue&type=style&index=0&id=5bf9dd86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../work/modules/node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf9dd86",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiSectionTitle: require('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod/components/ui/UiSectionTitle.vue').default,UiButton: require('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod/components/ui/UiButton.vue').default})
